/* JPY Collectibles — Neo-Tokyo interactions (reversibile: rimuovere insieme a neo-tokyo.css) */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var script = document.querySelector('script[data-nt-logo]');
  var LOGO = script ? script.getAttribute('data-nt-logo') : null;

  /* 1) sfondo: loghi fluttuanti + parallax (mouse) / giroscopio (mobile) */
  if (LOGO) {
    var spots = [
      {w:170,l:'4%', t:'12%', d:11, dl:0},{w:96, l:'74%',t:'6%', d:14, dl:-4},
      {w:140,l:'85%',t:'58%',d:12, dl:-7},{w:84, l:'14%',t:'70%',d:15, dl:-2},
      {w:115,l:'46%',t:'40%',d:17, dl:-9},{w:72, l:'62%',t:'84%',d:13, dl:-5},
      {w:125,l:'29%',t:'24%',d:18, dl:-11},{w:92, l:'92%',t:'30%',d:16, dl:-8}
    ];
    var wrapEl = document.createElement('div');
    wrapEl.className='nt-floaters'; wrapEl.setAttribute('aria-hidden','true');
    spots.forEach(function(p){
      var f=document.createElement('div'); f.className='nt-floater';
      f.style.cssText='width:'+p.w+'px;left:'+p.l+';top:'+p.t+';animation-duration:'+p.d+'s;animation-delay:'+p.dl+'s';
      var im=document.createElement('img'); im.src=LOGO; im.alt=''; im.loading='lazy';
      f.appendChild(im); wrapEl.appendChild(f);
    });
    document.body.appendChild(wrapEl);
    if(!reduce){
      /* il ciclo gira solo mentre i loghi si stanno spostando: a riposo zero lavoro (prima girava a ogni frame, per sempre) */
      var tx=0,ty=0,cx=0,cy=0,running=false;
      function raf(){
        cx+=(tx-cx)*0.07; cy+=(ty-cy)*0.07;
        if(Math.abs(tx-cx)<0.05 && Math.abs(ty-cy)<0.05){ cx=tx; cy=ty; running=false; }
        wrapEl.style.transform='translate('+cx.toFixed(2)+'px,'+cy.toFixed(2)+'px)';
        if(running) requestAnimationFrame(raf);
      }
      function kick(){ if(!running){ running=true; requestAnimationFrame(raf); } }
      window.addEventListener('pointermove',function(e){
        tx=(e.clientX/window.innerWidth-0.5)*-38; ty=(e.clientY/window.innerHeight-0.5)*-38; kick();
      },{passive:true});
      window.addEventListener('deviceorientation',function(e){
        if(e.gamma==null) return;
        var nx=Math.max(-30,Math.min(30,e.gamma))*-1.1, ny=Math.max(-30,Math.min(30,(e.beta||0)-45))*-1.1;
        if(Math.abs(nx-tx)<0.4 && Math.abs(ny-ty)<0.4) return;   /* rumore del sensore: ignorato */
        tx=nx; ty=ny; kick();
      },{passive:true});
    }
  }

  /* 2) menu: colore per gioco + pillola di vetro scorrevole */
  function gameOf(t){
    t=t.toLowerCase();
    if(t.indexOf('pok')>-1) return 'poke';
    if(t.indexOf('one')>-1) return 'op';
    if(t.indexOf('yu')>-1) return 'ygo';
    if(t.indexOf('dragon')>-1) return 'db';
    return '';
  }
  /* neon dedicato per OGNI voce del drawer mobile */
  function drawerKind(t){
    t=t.toLowerCase();
    if(t.indexOf('pok')>-1) return 'poke';
    if(t.indexOf('one')>-1) return 'op';
    if(t.indexOf('yu')>-1) return 'ygo';
    if(t.indexOf('dragon')>-1) return 'db';
    if(t.indexOf('singol')>-1) return 'sing';
    if(t.indexOf('access')>-1) return 'acc';
    if(t.indexOf('assist')>-1) return 'ass';
    return '';
  }
  var drawerColors={poke:'#ffcf3a',op:'#ff3d46',ygo:'#b06bff',db:'#ff8a3d',sing:'#ff5fa2',acc:'#5dffb0',ass:'#ffe35f'};
  var drawerExtras=['#ff5fa2','#5dffb0','#ffe35f','#ff7a4d'], dE=0;
  document.querySelectorAll('.menu-drawer__menu > li').forEach(function(li){
    var a=li.querySelector('.menu-drawer__menu-item');
    var g=drawerKind((a?a.textContent:li.textContent)||'');
    var c=drawerColors[g] || drawerExtras[(dE++)%drawerExtras.length];
    li.style.setProperty('--gc', c);   /* inline: vince su qualsiasi CSS */
    if(g) li.setAttribute('data-nt-game',g);
  });
  /* il "Visualizza tutte" della sezione Carte Singole punta alla pagina con tutte le singole */
  document.querySelectorAll('.collection a[href*="ar-chr-sets-pokemon"]').forEach(function(a){
    a.setAttribute('href', root0()+'pages/single-cards');
  });
  function root0(){ return (window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/'; }
  var nav=document.querySelector('.header__inline-menu .list-menu--inline');
  if(nav){
    var pill=document.createElement('span'); pill.className='nt-navpill'; pill.setAttribute('aria-hidden','true');
    nav.appendChild(pill);
    var cols={poke:'#ffcf3a',op:'#ff3d46',ygo:'#b06bff',db:'#ff8a3d',sing:'#ff5fa2',acc:'#5dffb0',ass:'#ffe35f'};
    nav.querySelectorAll(':scope > li').forEach(function(li){
      var g=drawerKind(li.textContent||''); if(g) li.setAttribute('data-nt-game',g);
      li.addEventListener('mouseenter',function(){
        var r=li.getBoundingClientRect();
        pill.style.left=(r.left+10)+'px'; pill.style.top=(r.bottom-5)+'px'; pill.style.width=(r.width-20)+'px';
        pill.style.setProperty('--pc', cols[g]||'#ff3d46');
      });
    });
  }

  /* 2b) chip neon accanto ai titoli di sezione */
  (function(){
    var ICO={
      bolt:'<svg viewBox="0 0 24 24"><path d="M13 2 5.5 13.5h5L9.5 22 18 10.5h-5.5L13 2Z"/></svg>',
      cards:'<svg viewBox="0 0 24 24"><rect x="4" y="6" width="10" height="14" rx="1.6" transform="rotate(-8 9 13)"/><rect x="10" y="4" width="10" height="14" rx="1.6" transform="rotate(7 15 11)"/></svg>',
      box:'<svg viewBox="0 0 24 24"><path d="M4 8.2 12 4l8 4.2v7.6L12 20l-8-4.2V8.2Z"/><path d="M4 8.2 12 12.4l8-4.2"/><path d="M12 12.4V20"/></svg>',
      spark:'<svg viewBox="0 0 24 24"><path d="M12 3v5M12 16v5M3 12h5M16 12h5M6.2 6.2l2.4 2.4M15.4 15.4l2.4 2.4M17.8 6.2l-2.4 2.4M8.6 15.4l-2.4 2.4"/></svg>'
    };
    function pick(t){
      t=t.toLowerCase();
      if(t.indexOf('uscit')>-1) return ['bolt','#ff3d46'];
      if(t.indexOf('singol')>-1) return ['cards','#b06bff'];
      if(t.indexOf('pok')>-1) return ['box','#ffcf3a'];
      if(t.indexOf('one piece')>-1||t.indexOf('one-piece')>-1) return ['box','#ff3d46'];
      if(t.indexOf('yu')>-1) return ['box','#b06bff'];
      if(t.indexOf('dragon')>-1) return ['box','#ff8a3d'];
      return ['spark','#ff3d46'];
    }
    document.querySelectorAll('.collection .title, .title-wrapper-with-link .title, .featured-collection .title').forEach(function(h){
      if(h.querySelector('.nt-chip')) return;
      var pc=pick(h.textContent||'');
      var chip=document.createElement('span');
      chip.className='nt-chip'; chip.setAttribute('aria-hidden','true');
      chip.style.setProperty('--cc', pc[1]);
      chip.innerHTML=ICO[pc[0]];
      h.insertBefore(chip, h.firstChild);
    });
  })();

  /* 2c) ricerca: il placeholder digita da solo prodotti dalle Ultime uscite */
  (function(){
    var titles=(window.__ntTitles||[]).filter(function(t){return t&&t.length>2});
    var inputs=document.querySelectorAll('input.search__input');
    if(!titles.length||!inputs.length) return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce){ inputs.forEach(function(i){i.setAttribute('placeholder','Cerca: '+titles[0])}); return; }
    var ti=Math.floor(Math.random()*titles.length), ci=0, deleting=false, tm=null;
    var CUR=String.fromCharCode(0x258f);   /* cursore di testo (U+258F) */
    function apply(txt){
      inputs.forEach(function(i){
        if(document.activeElement!==i && !i.value) i.setAttribute('placeholder', txt);
      });
    }
    /* scrive solo se almeno un campo di ricerca è visibile: quello dell'header resta chiuso quasi sempre */
    var hasIO='IntersectionObserver' in window;
    if(hasIO){
      var io=new IntersectionObserver(function(es){ es.forEach(function(e){ e.target.__ntVis=e.isIntersecting; }); });
      inputs.forEach(function(i){ io.observe(i); });
    }
    function anyVisible(){
      if(!hasIO) return true;
      for(var k=0;k<inputs.length;k++){ if(inputs[k].__ntVis) return true; }
      return false;
    }
    function tick(){
      if(!anyVisible()){ tm=setTimeout(tick, 500); return; }
      var t=titles[ti], wait;
      if(!deleting){
        ci++;
        apply(t.slice(0,ci)+CUR);
        if(ci>=t.length){ deleting=true; wait=1700; } else { wait=46+Math.random()*40; }
      } else {
        ci-=2;
        if(ci<=0){ ci=0; deleting=false; ti=(ti+1)%titles.length; apply(CUR); wait=420; }
        else { apply(t.slice(0,ci)+CUR); wait=24; }
      }
      tm=setTimeout(tick, wait);
    }
    document.addEventListener('visibilitychange',function(){
      if(document.hidden){ if(tm){clearTimeout(tm); tm=null;} } else if(!tm){ tick(); }
    });
    tick();
  })();

  /* 3) mobile: tab bar app-like */
  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  var tab=document.createElement('nav');
  tab.className='nt-tabbar'; tab.setAttribute('aria-label','Navigazione rapida');
  function item(href,label,svg,on){
    return '<a href="'+href+'"'+(on?' class="on"':'')+'>'+svg+label+'</a>';
  }
  var icoHome='<svg viewBox="0 0 24 24"><path d="M4 11.5 12 5l8 6.5V20a1 1 0 0 1-1 1h-5v-6h-4v6H5a1 1 0 0 1-1-1Z"/></svg>';
  var icoSearch='<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/></svg>';
  var icoCat='<svg viewBox="0 0 24 24"><rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/></svg>';
  var icoCart='<svg viewBox="0 0 24 24"><path d="M6.5 9h11l-.9 9.2a2 2 0 0 1-2 1.8H9.4a2 2 0 0 1-2-1.8L6.5 9Z"/><path d="M9 9V7a3 3 0 0 1 6 0v2"/></svg>';
  var path=location.pathname;
  tab.innerHTML =
    item(root,'Home',icoHome, path===root) +
    item(root+'search','Cerca',icoSearch, path.indexOf('/search')===0) +
    item(root+'collections','Categorie',icoCat, false) +
    item(root+'cart','Carrello'+'<span class="nt-tc" data-nt-cartcount hidden>0</span>',icoCart, path.indexOf('/cart')===0);
  document.body.appendChild(tab);
  /* "Categorie" apre il menu a tendina (stesse categorie del menu) */
  var catBtn=tab.children[2];
  catBtn.addEventListener('click',function(e){
    var drawer=document.querySelector('#Details-menu-drawer-container > summary, header-drawer summary');
    if(drawer){ e.preventDefault(); drawer.click(); }
  });
  function syncCart(){
    var bubble=document.querySelector('.cart-count-bubble span[aria-hidden]');
    var tc=tab.querySelector('[data-nt-cartcount]');
    if(!tc) return;
    var n=bubble?parseInt(bubble.textContent,10)||0:0;
    var txt=String(n), hid=(n===0);
    if(tc.textContent!==txt) tc.textContent=txt;   /* scrivi SOLO se cambia: niente loop */
    if(tc.hidden!==hid) tc.hidden=hid;
    var ca=tc.closest('a');
    if(ca){ var want=n>0; if(ca.classList.contains('nt-has')!==want) ca.classList.toggle('nt-has',want); }
  }
  syncCart();
  /* osserva SOLO l'icona carrello dell'header, non l'intero documento */
  var cartIcon=document.getElementById('cart-icon-bubble');
  new MutationObserver(syncCart).observe(cartIcon||document.body,{subtree:true,childList:true,characterData:true});
})();
